import { useQueryParam, NumberParam } from 'use-query-params';

export const useUrlPagination = (initialPage = 1, initialRows = 20) => {
  const [page, setPage] = useQueryParam('page', NumberParam, {
    updateType: 'replaceIn',
  });
  const [rows, setRows] = useQueryParam('rows', NumberParam, {
    updateType: 'replaceIn',
  });

  return {
    controlledPageIndex: page ?? initialPage,
    controlledRows: rows ?? initialRows,
    updateControlledPageIndex: setPage,
    updateControlledRows: setRows,
  };
};
